/* Slider section
--------------------------------------*/

class ProductsSection {
    constructor (parent) {
      if (!parent) {
        return;
      }
      this.parent = parent;
      this.viewAllButton = qs('.view-all-button-js',parent)
      this.clickEvent();
    }
  
    clickEvent = () => {
      let parent = this.parent;
  
      // load more products
      let viewAllButton = qs('.view-all-button-js',parent);
      viewAllButton?.addEventListener("click",(e)=>{
        let allLoadMore = qsa('.birthday-product-child-js',parent);
        allLoadMore?.forEach((item)=>{
          item.classList.remove('d-none');
        })
        viewAllButton.classList.remove('d-block');
        viewAllButton.classList.add('d-none');
      });
  
      // Filter init
      if(simply?.isFilterEnable) {
        qs('.tag-filter-js',parent)?.addEventListener("change",(e) =>{
          this.findFilterValue();
        });
        qs('.sort-by-js',parent)?.addEventListener("change",(e) => {
          this.findFilterValue();
        });
      }
    }
  
    findFilterValue = () => {
      let parent = this.parent;
  
      // Find Filter selected value
      let tagFilterValue = qs('.tag-filter-js',parent).value;
      let sortFilterValue = qs('.sort-by-js',parent).value;
      this.fetchFilterData(tagFilterValue,sortFilterValue);
    }
  
    fetchFilterData = (tagFilterValue,sortFilterValue) => {
      let parent = this.parent;
      // Fetch product data
      let collectionHandle = qs('.products-inner-wrap-js',parent)?.dataset?.collection;
      let url = `/collections/${collectionHandle}/${tagFilterValue}?sort_by=${sortFilterValue}&view=rakhi-filter`;
      fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setProductData(data);
      });
    }
  
    setProductData = async (products) => {
      let parent = this.parent;
      let productsInnerWrap = qs('.products-inner-wrap-js',parent);
      products.collectionData = products.collectionData.filter(item => item.prodData.available == true);
      let length = products.collectionData.length;
      if(length > 0){
        let html = await Promise.all(products.collectionData.map(async(product,index)=>{
          let productData = product.prodData;
          let productCard = await fetch(`/products/${productData.handle}?view=card`);
          productCard = await productCard.text();
          if (productCard) {
            return`<div class="birthday-product-child birthday-product-child-js${this.viewAllButton && index > 18 ? ' d-none':''}">${productCard}</div>`;
          }
        }));
        productsInnerWrap.innerHTML = html.join('');
        simply.productCardGlobal(qsa('.product-main-js'));
      }else{
        productsInnerWrap.innerHTML = '<p>No Products</p>';
      }
      if(length > 18){
        qs('.view-all-button-js',parent)?.classList.add('d-block');
        qs('.view-all-button-js',parent)?.classList.remove('d-none');
      }else{
        qs('.view-all-button-js',parent)?.classList.remove('d-block');
        qs('.view-all-button-js',parent)?.classList.add('d-none');
      }
    }
  }
  
  new ProductsSection(qs(".products-section-js"));
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      new ProductsSection(qs(".products-section-js"));
    });
  }
  